export function action(type, payload = {}) {
  return { type, ...payload };
}


// WEBPACK FOOTER //
// src/modules/presence/actions/actionCreator.js